import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  margin: 0 0 44px 0;
  position: relative;
z-index:999999;
  align-items: center;
  justify-content: space-between;



  .col-1 {
    display: flex;

    p {
      color: black;
      font-size: 22px;
      font-weight: 400;

      line-height: 120%;
      margin: 0 0 0 13px;
      
      font-style: normal;
    }
  }

  .col-2 {
    p {
      color: #004A80;
      font-size: 13px;

      cursor: pointer;
      font-weight: 400;
      
      line-height: 120%;
      font-style: normal;

      &:hover {
        text-decoration: underline
      }
    }
  }
`;